(() => {
  'use strict';

  const fulfillmentOptions = [
    {
      id: 'pickup',
      icon: '\u{1F3ED}',
      title: 'Warehouse Pickup',
      resultTitle: 'Warehouse Pickup',
      detail: '5460 Colorado Blvd Service Rd.\nCommerce City, CO 80022'
    },
    {
      id: 'local',
      icon: '\u{1F69A}',
      title: 'Local Delivery',
      resultTitle: 'Local Delivery (CO)',
      detail: 'Colorado only'
    },
    {
      id: 'shipping',
      icon: '\u{1F4E6}',
      title: 'Ship to Me',
      resultTitle: 'Shipping (48 states)',
      detail: 'All 48 states',
      warning: '20 lb order minimum'
    }
  ];

  const allergyProteinKeys = ['chicken', 'beef', 'turkey', 'duck', 'fish', 'lamb'];
  const SHIPPING_MINIMUM_LBS = 20;
  const QUANTITY_ROUNDING_EPSILON = 1e-9;
  const SHOPIFY_PRODUCT_DATA_TIMEOUT_MS = 8000;
  const CONSULTATION_URL = 'https://shoprawdogfood.rawdogfoodandco.com/pages/rdf-consult';
  const DOG_BREEDS = [
    'Affenpinscher',
    'Afghan Hound',
    'Airedale Terrier',
    'Akita',
    'Alaskan Malamute',
    'American English Coonhound',
    'American Eskimo Dog',
    'American Foxhound',
    'American Hairless Terrier',
    'American Staffordshire Terrier',
    'American Water Spaniel',
    'Anatolian Shepherd Dog',
    'Australian Cattle Dog',
    'Australian Shepherd',
    'Australian Terrier',
    'Azawakh',
    'Barbet',
    'Basenji',
    'Basset Fauve de Bretagne',
    'Basset Hound',
    'Beagle',
    'Bearded Collie',
    'Beauceron',
    'Bedlington Terrier',
    'Belgian Laekenois',
    'Belgian Malinois',
    'Belgian Sheepdog',
    'Belgian Tervuren',
    'Bergamasco Sheepdog',
    'Berger Picard',
    'Bernese Mountain Dog',
    'Bichon Frise',
    'Biewer Terrier',
    'Black and Tan Coonhound',
    'Black Russian Terrier',
    'Bloodhound',
    'Bluetick Coonhound',
    'Boerboel',
    'Border Collie',
    'Border Terrier',
    'Borzoi',
    'Boston Terrier',
    'Bouvier des Flandres',
    'Boxer',
    'Boykin Spaniel',
    'Bracco Italiano',
    'Briard',
    'Brittany',
    'Brussels Griffon',
    'Bull Terrier',
    'Bulldog',
    'Bullmastiff',
    'Cairn Terrier',
    'Canaan Dog',
    'Cane Corso',
    'Cardigan Welsh Corgi',
    'Cavalier King Charles Spaniel',
    'Cesky Terrier',
    'Chesapeake Bay Retriever',
    'Chihuahua',
    'Chinese Crested',
    'Chinese Shar-Pei',
    'Chinook',
    'Chow Chow',
    'Cirneco dell\u2019Etna',
    'Clumber Spaniel',
    'Cocker Spaniel',
    'Collie',
    'Coton de Tulear',
    'Curly-Coated Retriever',
    'Dachshund',
    'Dalmatian',
    'Dandie Dinmont Terrier',
    'Danish-Swedish Farmdog',
    'Doberman Pinscher',
    'Dogo Argentino',
    'Dogue de Bordeaux',
    'English Cocker Spaniel',
    'English Foxhound',
    'English Setter',
    'English Springer Spaniel',
    'English Toy Spaniel',
    'Entlebucher Mountain Dog',
    'Field Spaniel',
    'Finnish Lapphund',
    'Finnish Spitz',
    'Flat-Coated Retriever',
    'French Bulldog',
    'German Pinscher',
    'German Shepherd Dog',
    'German Shorthaired Pointer',
    'German Wirehaired Pointer',
    'Giant Schnauzer',
    'Glen of Imaal Terrier',
    'Golden Retriever',
    'Goldendoodle',
    'Gordon Setter',
    'Grand Basset Griffon Vend\u00E9en',
    'Great Dane',
    'Great Pyrenees',
    'Greater Swiss Mountain Dog',
    'Greyhound',
    'Harrier',
    'Havanese',
    'Ibizan Hound',
    'Icelandic Sheepdog',
    'Irish Red and White Setter',
    'Irish Setter',
    'Irish Terrier',
    'Irish Water Spaniel',
    'Irish Wolfhound',
    'Italian Greyhound',
    'Japanese Chin',
    'Keeshond',
    'Kerry Blue Terrier',
    'Komondor',
    'Kuvasz',
    'Labradoodle',
    'Labrador Retriever',
    'Lagotto Romagnolo',
    'Lakeland Terrier',
    'Lancashire Heeler',
    'Leonberger',
    'Lhasa Apso',
    'L\u00F6wchen',
    'Maltese',
    'Manchester Terrier',
    'Mastiff',
    'Miniature American Shepherd',
    'Miniature Bull Terrier',
    'Miniature Pinscher',
    'Miniature Poodle',
    'Miniature Schnauzer',
    'Mixed Breed',
    'Mudi',
    'Neapolitan Mastiff',
    'Nederlandse Kooikerhondje',
    'Newfoundland',
    'Norfolk Terrier',
    'Norwegian Buhund',
    'Norwegian Elkhound',
    'Norwegian Lundehund',
    'Norwich Terrier',
    'Nova Scotia Duck Tolling Retriever',
    'Old English Sheepdog',
    'Otterhound',
    'Papillon',
    'Parson Russell Terrier',
    'Pekingese',
    'Pembroke Welsh Corgi',
    'Petit Basset Griffon Vend\u00E9en',
    'Pharaoh Hound',
    'Plott Hound',
    'Pointer',
    'Polish Lowland Sheepdog',
    'Pomeranian',
    'Poodle',
    'Portuguese Podengo Pequeno',
    'Portuguese Water Dog',
    'Pug',
    'Puli',
    'Pumi',
    'Pyrenean Shepherd',
    'Rat Terrier',
    'Redbone Coonhound',
    'Rhodesian Ridgeback',
    'Rottweiler',
    'Russell Terrier',
    'Russian Toy',
    'Russian Tsvetnaya Bolonka',
    'Saint Bernard',
    'Saluki',
    'Samoyed',
    'Schipperke',
    'Scottish Deerhound',
    'Scottish Terrier',
    'Sealyham Terrier',
    'Shetland Sheepdog',
    'Shiba Inu',
    'Shih Tzu',
    'Siberian Husky',
    'Silky Terrier',
    'Skye Terrier',
    'Sloughi',
    'Smooth Fox Terrier',
    'Soft Coated Wheaten Terrier',
    'Spanish Water Dog',
    'Spinone Italiano',
    'Staffordshire Bull Terrier',
    'Standard Poodle',
    'Standard Schnauzer',
    'Sussex Spaniel',
    'Swedish Vallhund',
    'Teddy Roosevelt Terrier',
    'Tibetan Mastiff',
    'Tibetan Spaniel',
    'Tibetan Terrier',
    'Toy Fox Terrier',
    'Toy Poodle',
    'Treeing Walker Coonhound',
    'Vizsla',
    'Weimaraner',
    'Welsh Springer Spaniel',
    'Welsh Terrier',
    'West Highland White Terrier',
    'Whippet',
    'Wire Fox Terrier',
    'Wirehaired Pointing Griffon',
    'Wirehaired Vizsla',
    'Xoloitzcuintli',
    'Yorkshire Terrier',
    'My Breed Not Listed'
  ];
  const CAT_BREEDS = [
    'Abyssinian',
    'American Bobtail',
    'American Bobtail Shorthair',
    'American Curl',
    'American Curl Longhair',
    'American Shorthair',
    'American Wirehair',
    'Australian Mist',
    'Balinese',
    'Bengal',
    'Bengal Longhair',
    'Birman',
    'Bombay',
    'British Longhair',
    'British Shorthair',
    'Burmese',
    'Burmilla',
    'Burmilla Longhair',
    'Chartreux',
    'Chausie',
    'Cherubim',
    'Cornish Rex',
    'Cymric',
    'Cymric Tailed',
    'Devon Rex',
    'Domestic Longhair',
    'Domestic Shorthair',
    'Donskoy',
    'Egyptian Mau',
    'Exotic Shorthair',
    'Havana',
    'Highlander',
    'Highlander Shorthair',
    'Himalayan',
    'Japanese Bobtail',
    'Japanese Bobtail Longhair',
    'Khaomanee',
    'Korat',
    'Kurilian Bobtail',
    'Kurilian Bobtail Longhair',
    'LaPerm',
    'LaPerm Shorthair',
    'Lykoi',
    'Maine Coon',
    'Maine Coon Polydactyl',
    'Manx',
    'Manx Tailed',
    'Minuet',
    'Minuet Longhair',
    'Minuet Talls',
    'Minuet Talls Longhair',
    'Mixed Breed',
    'Munchkin',
    'Munchkin Longhair',
    'Nebelung',
    'Norwegian Forest',
    'Ocicat',
    'Oriental Longhair',
    'Oriental Shorthair',
    'Persian',
    'Peterbald',
    'Pixiebob',
    'Pixiebob Longhair',
    'Ragdoll',
    'Russian Blue',
    'Savannah',
    'Scottish Fold',
    'Scottish Fold Longhair',
    'Scottish Straight',
    'Scottish Straight Longhair',
    'Selkirk Rex',
    'Selkirk Rex Longhair',
    'Serengeti',
    'Siamese',
    'Siberian',
    'Singapura',
    'Snowshoe',
    'Somali',
    'Sphynx',
    'Tennessee Rex',
    'Thai',
    'Tonkinese',
    'Toybob',
    'Toyger',
    'Turkish Angora',
    'Turkish Van',
    'My Breed Not Listed'
  ];

  const positiveNumber = (value, fieldName) => {
    const number = Number(value);

    if (!Number.isFinite(number) || number <= 0) {
      throw new TypeError(`${fieldName} must be a number greater than 0.`);
    }

    return number;
  };

  /**
   * Converts a plan's required food weight into a purchasable variant quantity.
   *
   * Uses the v6 routing formula: pickup/local rounds required pounds up to full
   * units; shipping also enforces the product's configured minimum quantity.
   *
   * @param {Object} options
   * @param {number|string} options.requiredLbs Required food for the selected plan.
   * @param {number|string} options.unitWeightLbs Weight of one regular product variant.
   * @param {string} options.fulfillment pickup, local, or shipping.
   * @param {number|string} [options.minimumShippingLbs=20]
   * @param {number|string} [options.minimumShippingQty]
   * @returns {Object}
   */
  const calculateVariantQuantity = ({
    requiredLbs,
    unitWeightLbs,
    fulfillment,
    minimumShippingLbs = SHIPPING_MINIMUM_LBS,
    minimumShippingQty = ''
  } = {}) => {
    const requiredWeight = positiveNumber(requiredLbs, 'requiredLbs');
    const unitWeight = positiveNumber(unitWeightLbs, 'unitWeightLbs');
    const shippingMinimum = positiveNumber(minimumShippingLbs, 'minimumShippingLbs');
    const minimumApplies = fulfillment === 'shipping';
    const configuredMinimumQty = minimumShippingQty === ''
      ? Math.ceil((shippingMinimum / unitWeight) - QUANTITY_ROUNDING_EPSILON)
      : positiveInteger(minimumShippingQty, 'minimumShippingQty');
    const requiredQuantity = Math.max(
      1,
      Math.ceil((requiredWeight / unitWeight) - QUANTITY_ROUNDING_EPSILON)
    );
    const quantity = minimumApplies
      ? Math.max(configuredMinimumQty, requiredQuantity)
      : requiredQuantity;
    const cartWeightLbs = quantity * unitWeight;
    const targetWeight = minimumApplies
      ? Math.max(requiredWeight, configuredMinimumQty * unitWeight)
      : requiredWeight;

    return {
      requiredLbs: requiredWeight,
      unitWeightLbs: unitWeight,
      targetLbs: targetWeight,
      quantity,
      cartWeightLbs,
      extraLbs: Math.max(0, cartWeightLbs - requiredWeight),
      shippingMinimumLbs: shippingMinimum,
      minimumShippingQty: configuredMinimumQty,
      shippingMinimumApplied: minimumApplies && requiredWeight < shippingMinimum,
      meetsShippingMinimum: !minimumApplies || cartWeightLbs >= shippingMinimum
    };
  };

  const normalizeEquivalentSupplyPrices = ({
    twoPrice,
    fourPrice,
    twoPeriod,
    fourPeriod
  }) => {
    const sameAdjustedSupply = (
      twoPeriod.adjusted
      && fourPeriod.adjusted
      && twoPeriod.days === fourPeriod.days
      && Math.abs(twoPeriod.totalLbs - fourPeriod.totalLbs) < QUANTITY_ROUNDING_EPSILON
    );

    if (!sameAdjustedSupply) {
      return { two: twoPrice, four: fourPrice, normalized: false };
    }

    const canonicalPrice = twoPrice.totalPrice <= fourPrice.totalPrice
      ? twoPrice
      : fourPrice;

    return {
      two: { ...canonicalPrice },
      four: { ...canonicalPrice },
      normalized: true
    };
  };

  const SHOPIFY_CART_ADD_ENDPOINT = '/cart/add.js';
  const activeCartRequests = new Map();

  const positiveInteger = (value, fieldName) => {
    const number = Number(value);

    if (!Number.isSafeInteger(number) || number <= 0) {
      throw new TypeError(`${fieldName} must be a positive integer.`);
    }

    return number;
  };

  const normalizeCartProperties = (properties = {}) => {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      throw new TypeError('Cart item properties must be an object.');
    }

    return Object.keys(properties)
      .sort()
      .reduce((normalized, key) => {
        const value = properties[key];
        if (value !== undefined && value !== null && value !== '') {
          normalized[key] = String(value);
        }
        return normalized;
      }, {});
  };

  /**
   * Creates private Shopify line-item properties for one Feed Plan item.
   * Shopify keeps properties prefixed with an underscore out of the standard
   * storefront display while retaining them on the cart/order line item.
   */
  const buildFeedPlanLineItemProperties = ({
    petName = '',
    petType = '',
    breed = '',
    lifeStage = '',
    planName = '',
    planKey = '',
    supplyDays = '',
    dailyOz = '',
    dailyLbs = '',
    totalLbs = '',
    fulfillment = '',
    addonName = ''
  } = {}) => {
    const dailyPortion = dailyOz !== '' && dailyLbs !== ''
      ? `${dailyOz} oz (${dailyLbs} lbs) per day`
      : '';
    const totalWeight = totalLbs === ''
      ? ''
      : `${positiveNumber(totalLbs, 'totalLbs').toFixed(1)} lbs`;
    const supply = supplyDays === ''
      ? ''
      : `${positiveInteger(supplyDays, 'supplyDays')}-day supply`;

    return normalizeCartProperties({
      '_RDF Pet': petName,
      '_RDF Pet Type': petType,
      '_RDF Breed': breed,
      '_RDF Life Stage': lifeStage,
      '_RDF Plan': planName,
      '_RDF Plan Key': planKey,
      '_RDF Supply': supply,
      '_RDF Daily Portion': dailyPortion,
      '_RDF Plan Weight': totalWeight,
      '_RDF Fulfillment': fulfillment,
      '_RDF Purchase Option': 'One-time purchase',
      '_RDF Item Type': addonName ? 'Add-on' : 'Food plan',
      '_RDF Add-on': addonName
    });
  };

  /**
   * Converts product and add-on selections into Shopify Ajax Cart line items.
   *
   * The v6 FR-80 map supplies variantId and quantity. Subscription selling
   * plans are intentionally excluded based on the current client direction.
   * Duplicate variants are merged only when their properties are identical,
   * so separate pets can retain separate line items.
   */
  const buildShopifyCartItems = (selections = []) => {
    if (!Array.isArray(selections)) {
      throw new TypeError('Cart selections must be an array.');
    }

    const mergedItems = new Map();

    selections.forEach((selection, index) => {
      if (!selection || typeof selection !== 'object') {
        throw new TypeError(`Cart selection ${index + 1} must be an object.`);
      }

      const id = positiveInteger(
        selection.variantId ?? selection.id,
        `Cart selection ${index + 1} variantId`
      );
      const quantity = positiveInteger(
        selection.quantity ?? 1,
        `Cart selection ${index + 1} quantity`
      );
      const properties = normalizeCartProperties(selection.properties);
      const key = JSON.stringify({ id, properties });

      if (mergedItems.has(key)) {
        mergedItems.get(key).quantity += quantity;
        return;
      }

      const item = { id, quantity };
      if (Object.keys(properties).length) item.properties = properties;
      mergedItems.set(key, item);
    });

    return [...mergedItems.values()];
  };

  /**
   * Builds one /cart/add.js payload containing the selected food products and
   * optional add-ons. No live request is sent by this function.
   */
  const buildShopifyCartAddPayload = ({
    products = [],
    addons = [],
    sections,
    sectionsUrl
  } = {}) => {
    const items = buildShopifyCartItems([...products, ...addons]);

    if (!items.length) {
      throw new Error('At least one mapped product or add-on is required.');
    }

    const payload = { items };
    if (Array.isArray(sections) && sections.length) payload.sections = sections;
    if (typeof sections === 'string' && sections.trim()) payload.sections = sections.trim();
    if (typeof sectionsUrl === 'string' && sectionsUrl.trim()) {
      payload.sections_url = sectionsUrl.trim();
    }

    return payload;
  };

  const shopifyCartAddEndpoint = () => {
    const shopRoot = globalThis.Shopify?.routes?.root;
    if (!shopRoot) return SHOPIFY_CART_ADD_ENDPOINT;
    return `${String(shopRoot).replace(/\/?$/, '/')}cart/add.js`;
  };

  /**
   * Sends a prepared multi-item request to Shopify's Ajax Cart API.
   * The v6 product map supplies the live variant IDs. Subscription selling
   * plans remain intentionally excluded until a separate plan is approved.
   */
  const addItemsToShopifyCart = async ({
    products = [],
    addons = [],
    sections,
    sectionsUrl,
    endpoint = shopifyCartAddEndpoint(),
    fetchImpl = globalThis.fetch
  } = {}) => {
    if (typeof fetchImpl !== 'function') {
      throw new TypeError('A fetch implementation is required to add items to cart.');
    }

    const payload = buildShopifyCartAddPayload({
      products,
      addons,
      sections,
      sectionsUrl
    });
    const requestKey = `${endpoint}:${JSON.stringify(payload)}`;
    if (activeCartRequests.has(requestKey)) {
      return activeCartRequests.get(requestKey);
    }

    const request = (async () => {
      const response = await fetchImpl(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const responseBody = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = responseBody.description
          || responseBody.message
          || `Shopify cart request failed with status ${response.status}.`;
        const error = new Error(message);
        error.status = response.status;
        error.response = responseBody;
        throw error;
      }

      return responseBody;
    })().finally(() => {
      activeCartRequests.delete(requestKey);
    });

    activeCartRequests.set(requestKey, request);
    return request;
  };

  const ENABLE_SAFE_SEA_FOR_CATS = false;

  const foodProducts = {
    beefRecipe: {
      id: 'beef-recipe-2lb',
      handle: 'beef-healthy-variety-mix-1',
      variantId: '41006679064748',
      preferredVariantTitle: '2 lb Roll',
      unitWeightLbs: 2,
      minimumShippingQty: 10,
      primaryProtein: 'beef',
      proteinKeys: ['beef'],
      icon: '\u{1F969}',
      name: 'Beef Recipe with Veggies (2 lb roll)',
      price: 15.00,
      ribbon: 'Recommended',
      ribbonType: 'popular',
      copy: 'A balanced beef recipe with vegetables in convenient 2 lb rolls.'
    },
    beginnersChoice: {
      id: 'beginners-choice-2lb',
      handle: 'beginners-choice',
      variantId: '29868548554834',
      preferredVariantTitle: '2 lb Roll now with finely milled fish bone',
      unitWeightLbs: 2,
      minimumShippingQty: 10,
      primaryProtein: 'beef',
      proteinKeys: ['beef', 'fish'],
      icon: '\u{1F969}',
      name: 'Beginners Choice (2 lb roll)',
      price: 12.44,
      ribbon: 'Alternative',
      ribbonType: 'value',
      copy: 'A beef and tripe blend with sardines and finely milled salmon fish bone.'
    },
    chickenMix: {
      id: 'chicken-mix-2lb',
      handle: 'chicken-pmr-blend-made-with-organic-chicken',
      variantId: '41029391646892',
      preferredVariantTitle: '2 lb Roll',
      unitWeightLbs: 2,
      minimumShippingQty: 10,
      primaryProtein: 'chicken',
      proteinKeys: ['chicken'],
      icon: '\u{1F357}',
      name: 'Chicken Mix (2 lb roll)',
      price: 10.62,
      ribbon: 'Single Protein',
      ribbonType: 'value',
      copy: 'A chicken-based single-protein option used for the beef-allergy path.'
    },
    turkeyMix: {
      id: 'turkey-mix-2lb',
      handle: 'turkey-prey-blend',
      variantId: '21384853028946',
      preferredVariantTitle: '2 lb Roll',
      unitWeightLbs: 2,
      minimumShippingQty: 10,
      primaryProtein: 'turkey',
      proteinKeys: ['turkey'],
      icon: '\u{1F983}',
      name: 'Turkey Mix (2 lb roll)',
      price: 11.80,
      ribbon: 'Single Protein',
      ribbonType: 'popular',
      copy: 'A turkey-based single-protein fallback for pets that need a different option.'
    },
    porkMix: {
      id: 'pork-mix-2lb',
      handle: 'pork-prey-blend',
      variantId: '21363707805778',
      preferredVariantTitle: '2 lb Roll',
      unitWeightLbs: 2,
      minimumShippingQty: 10,
      primaryProtein: 'pork',
      proteinKeys: ['pork'],
      icon: '\u{1F437}',
      name: 'Pork Mix (2 lb roll)',
      price: 13.22,
      ribbon: 'Single Protein',
      ribbonType: 'value',
      copy: 'A pork-based single-protein fallback for deeper allergy routes.'
    },
    healthyVariety: {
      id: 'healthy-variety-10lb',
      handle: 'raw-box-healthy-variety-mix',
      variantId: '37712427084',
      preferredVariantTitle: 'Raw Box HVM',
      unitWeightLbs: 10,
      minimumShippingQty: 2,
      primaryProtein: '',
      proteinKeys: ['beef', 'chicken', 'turkey', 'lamb', 'pork'],
      icon: '\u{1F37D}\uFE0F',
      name: 'Healthy Variety Mix Raw Box (10 lb)',
      price: 68.58,
      ribbon: 'Variety Box',
      ribbonType: 'combo',
      copy: 'A 10 lb rotation of beef, chicken, turkey, lamb, and pork.'
    },
    varietyPrey: {
      id: 'variety-prey-10lb',
      handle: 'real-raw-variety-pack',
      variantId: '19034541126',
      preferredVariantTitle: 'Variety Prey Mix',
      unitWeightLbs: 10,
      minimumShippingQty: 2,
      primaryProtein: '',
      proteinKeys: ['beef', 'pork', 'duck', 'rabbit', 'salmon', 'chicken', 'turkey', 'fish'],
      icon: '\u{1F37D}\uFE0F',
      name: 'Variety Prey Mix Raw Box (10 lb)',
      price: 67.99,
      ribbon: 'Variety Box',
      ribbonType: 'popular',
      copy: 'A 10 lb prey-model rotation with beef, pork, duck, rabbit, salmon, chicken, turkey, and fish.'
    },
    tripeVariety: {
      id: 'tripe-variety-10lb',
      handle: 'real-raw-tripe-variety-pack',
      variantId: '19034540934',
      preferredVariantTitle: 'Tripe Variety Raw Box',
      unitWeightLbs: 10,
      minimumShippingQty: 2,
      primaryProtein: '',
      proteinKeys: ['beef', 'rabbit', 'fish', 'chicken'],
      icon: '\u{1F37D}\uFE0F',
      name: 'Tripe Variety Mix Raw Box (10 lb)',
      price: 67.98,
      ribbon: 'Variety Box',
      ribbonType: 'combo',
      copy: 'A 10 lb tripe variety box with beef, rabbit, fish, and chicken.'
    }
  };

  const addonProducts = {
    beefLung: { id: 'beef-lung', handle: 'beef-lung-odor-free-5-oz-new-item', variantId: '40051156451500', preferredVariantTitle: '5 oz Package', proteinKeys: ['beef'], icon: '\u{1F953}', name: 'Pure Beef Lung Treats (5 oz)', price: 16.38, copy: 'Single-ingredient air-dried beef lung treats.' },
    bisonLung: { id: 'bison-lung', handle: 'pure-bison-lung-treats', variantId: '42232545640620', preferredVariantTitle: '5 oz Package', proteinKeys: ['bison'], icon: '\u{1F9AC}', name: 'Pure Bison Lung Treats (5 oz)', price: 17.45, copy: 'Single-ingredient bison lung treats and a novel-protein reward.' },
    bovineColostrum: { id: 'bovine-colostrum', handle: 'bovine-colostrum', variantId: '42608753246380', preferredVariantTitle: '60 Day Large Dog Supply', proteinKeys: [], icon: '\u{1F33F}', name: 'Bovine Colostrum', price: 35.09, copy: 'Supplement support for dogs with itching and skin concerns.' },
    yeastGuard: { id: 'yeast-guard', handle: 'yeast-guard', variantId: '42512635134124', preferredVariantTitle: 'Default Title', proteinKeys: [], icon: '\u{1F33F}', name: 'Yeast Guard', price: 40.11, copy: 'Targeted support for yeast-related skin and allergy concerns.' },
    healthyGut: { id: 'healthy-gut', handle: 'healthy-gut-digestive-enzyme-rebalance-digestive-flora', variantId: '32255295193170', preferredVariantTitle: '1.4 ounces', proteinKeys: [], icon: '\u{1F9A0}', name: 'Healthy Gut Digestive Enzyme', price: 34.99, copy: 'Digestive enzymes that support food breakdown and healthy digestion.' },
    gutSoothe: { id: 'gut-soothe', handle: 'gut-soothe-for-dogs-and-cats', variantId: '31708821717074', preferredVariantTitle: '1.8 oz Jar', proteinKeys: [], icon: '\u{1F49A}', name: 'Gut Soothe', price: 34.99, copy: 'Digestive support for diarrhea and intestinal upset.' },
    theWolf: { id: 'the-wolf', handle: 'the-wolf-species-appropriate-probiotic', variantId: '42292186775724', preferredVariantTitle: 'Default Title', proteinKeys: [], icon: '\u{1F43A}', name: 'The Wolf Probiotic', price: 60.17, copy: 'A species-appropriate probiotic for canine gut support.' },
    loveBugs: { id: 'love-bugs', handle: 'love-bugs-pre-probiotic-dogs-cats', variantId: '21986931802194', preferredVariantTitle: '40 Grams', proteinKeys: [], icon: '\u{1F41B}', name: 'Love Bugs Pre & Probiotic', price: 31.99, copy: 'A prebiotic and probiotic blend for dogs and cats.' },
    safeSea: { id: 'safe-sea', handle: 'green-lipid-mussel-oil', variantId: '37888927039660', preferredVariantTitle: 'Default Title', proteinKeys: [], icon: '\u{1F30A}', name: 'Safe-Sea Green Lipped Mussel Oil', price: 35.09, copy: 'Omega-3 and green-lipped mussel oil support for skin health.' }
  };

  const mappedShopifyItems = () => [
    ...Object.values(foodProducts),
    ...Object.values(addonProducts)
  ];

  const normalizeShopifyValue = (value = '') => String(value).trim().toLowerCase();

  const selectShopifyVariant = (productData = {}, mappedItem = {}) => {
    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    if (!variants.length) return null;

    const preferredSku = normalizeShopifyValue(mappedItem.preferredSku);
    const preferredTitle = normalizeShopifyValue(mappedItem.preferredVariantTitle);
    const currentVariantId = String(mappedItem.variantId || '');

    if (preferredSku) {
      const skuMatch = variants.find((variant) => (
        normalizeShopifyValue(variant.sku) === preferredSku
      ));
      if (skuMatch) return skuMatch;
    }

    if (preferredTitle) {
      const titleMatch = variants.find((variant) => (
        normalizeShopifyValue(variant.title) === preferredTitle
      ));
      if (titleMatch) return titleMatch;
    }

    const idMatch = variants.find((variant) => String(variant.id) === currentVariantId);
    if (idMatch) return idMatch;

    return variants.length === 1 ? variants[0] : null;
  };

  const unitWeightFromVariant = (variant = {}) => {
    const titleMatch = String(variant.title || '').match(/(\d+(?:\.\d+)?)\s*lb\b/i);
    if (titleMatch) return Number(titleMatch[1]);

    const weight = Number(variant.weight);
    const unit = normalizeShopifyValue(variant.weight_unit);
    if (!Number.isFinite(weight) || weight <= 0) return 0;
    if (unit === 'lb' || unit === 'lbs') return weight;
    if (unit === 'oz') return weight / 16;
    if (unit === 'kg') return weight * 2.2046226218;
    if (unit === 'g') return weight / 453.59237;
    return 0;
  };

  const liveProductName = (productData = {}, variant = {}) => {
    const title = String(productData.title || '').trim();
    const variantTitle = String(variant.title || '').trim();
    const hasMeaningfulVariant = variantTitle
      && normalizeShopifyValue(variantTitle) !== 'default title'
      && Array.isArray(productData.variants)
      && productData.variants.length > 1;

    if (!title) return variantTitle;
    return hasMeaningfulVariant ? `${title} \u2014 ${variantTitle}` : title;
  };

  const applyShopifyProductData = (mappedItem, productData = {}) => {
    const variant = selectShopifyVariant(productData, mappedItem);
    if (!variant) {
      mappedItem.available = false;
      mappedItem.liveDataStatus = 'variant-missing';
      return false;
    }

    const livePriceCents = Number(variant.price);
    const parsedUnitWeight = unitWeightFromVariant(variant);
    const productHandle = String(productData.handle || mappedItem.handle || '').trim();

    mappedItem.handle = productHandle || mappedItem.handle;
    mappedItem.variantId = String(variant.id);
    mappedItem.variantTitle = String(variant.title || mappedItem.preferredVariantTitle || '');
    mappedItem.sku = String(variant.sku || '');
    mappedItem.available = productData.available !== false && variant.available !== false;
    mappedItem.liveDataStatus = 'live';

    if (Number.isFinite(livePriceCents) && livePriceCents >= 0) {
      mappedItem.price = livePriceCents / 100;
    }

    const updatedName = liveProductName(productData, variant);
    if (updatedName) mappedItem.name = updatedName;

    mappedItem.imageUrl = productData.featured_image
      || productData.featuredImage
      || (Array.isArray(productData.images) ? productData.images[0] : '')
      || mappedItem.imageUrl
      || '';
    mappedItem.productUrl = productHandle
      ? `/products/${productHandle}?variant=${mappedItem.variantId}`
      : mappedItem.productUrl || '';

    if (mappedItem.unitWeightLbs && parsedUnitWeight > 0) {
      mappedItem.unitWeightLbs = parsedUnitWeight;
      mappedItem.minimumShippingQty = Math.max(
        1,
        Math.ceil(SHIPPING_MINIMUM_LBS / parsedUnitWeight - QUANTITY_ROUNDING_EPSILON)
      );
    }

    return true;
  };

  const shopifyProductJsonUrl = (handle) => {
    const root = typeof Shopify !== 'undefined' && Shopify.routes?.root
      ? Shopify.routes.root
      : '/';
    return `${root}products/${encodeURIComponent(handle)}.js`;
  };

  const fetchShopifyProductData = async (handle, fetchImpl = fetch) => {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeoutId = setTimeout(() => controller?.abort(), SHOPIFY_PRODUCT_DATA_TIMEOUT_MS);

    try {
      const response = await fetchImpl(shopifyProductJsonUrl(handle), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        ...(controller ? { signal: controller.signal } : {})
      });
      if (!response.ok) {
        throw new Error(`Unable to load Shopify product ${handle} (${response.status}).`);
      }
      return response.json();
    } finally {
      clearTimeout(timeoutId);
    }
  };

  const hydrateMappedProductsFromShopify = async (fetchImpl = fetch) => {
    const itemsByHandle = new Map();
    mappedShopifyItems().forEach((item) => {
      if (!item.handle) return;
      if (!itemsByHandle.has(item.handle)) itemsByHandle.set(item.handle, []);
      itemsByHandle.get(item.handle).push(item);
    });

    const results = await Promise.all([...itemsByHandle.entries()].map(async ([handle, items]) => {
      try {
        const productData = await fetchShopifyProductData(handle, fetchImpl);
        const updated = items.map((item) => applyShopifyProductData(item, productData));
        return { handle, status: updated.every(Boolean) ? 'live' : 'variant-missing' };
      } catch (error) {
        items.forEach((item) => {
          item.liveDataStatus = 'fallback';
          item.liveDataError = error instanceof Error ? error.message : String(error);
        });
        return { handle, status: 'fallback' };
      }
    }));

    return {
      live: results.filter((result) => result.status === 'live').length,
      fallback: results.filter((result) => result.status === 'fallback').length,
      variantMissing: results.filter((result) => result.status === 'variant-missing').length,
      results
    };
  };

  let productHydrationPromise = null;
  const hydrateMappedProductsOnce = () => {
    if (!productHydrationPromise) {
      productHydrationPromise = hydrateMappedProductsFromShopify();
    }
    return productHydrationPromise;
  };

  const proteinKeysForItem = (item = {}) => {
    if (Array.isArray(item.proteinKeys)) return item.proteinKeys;
    return item.primaryProtein ? [item.primaryProtein] : [];
  };

  const hasAllergenConflict = (item, flaggedProteins = []) => (
    proteinKeysForItem(item).some((proteinKey) => flaggedProteins.includes(proteinKey))
  );

  const filterAllergenUnsafeItems = (items = [], flaggedProteins = []) => (
    items.filter((item) => item.available !== false && !hasAllergenConflict(item, flaggedProteins))
  );

  const hasSensitiveConcerns = (pet = {}) => {
    const concerns = Array.isArray(pet.concerns) ? pet.concerns : [];
    return concerns.includes('skin') || concerns.includes('digestion');
  };

  const usesPorkTripeFallback = (pet = {}, flaggedProteins = []) => {
    const flags = [...new Set(flaggedProteins)];
    return pet.type === 'dog'
      && flags.length === 3
      && ['beef', 'chicken', 'turkey'].every((protein) => flags.includes(protein));
  };

  const usesFishVarietyRoute = (pet = {}, flaggedProteins = []) => {
    const flags = [...new Set(flaggedProteins)];
    return pet.type === 'dog'
      && flags.length === 1
      && flags[0] === 'fish';
  };

  const recommendedProductPoolForPet = (pet = {}, flaggedProteins = []) => {
    const flags = [...new Set(flaggedProteins)];
    const usePorkTripeFallback = usesPorkTripeFallback(pet, flags);
    const useFishVarietyRoute = usesFishVarietyRoute(pet, flags);
    let candidates;

    if (pet.type === 'cat') {
      candidates = [foodProducts.healthyVariety, foodProducts.varietyPrey];
    } else if (!flags.length) {
      candidates = [foodProducts.beefRecipe, foodProducts.healthyVariety];
    } else if (pet.type === 'dog' && flags.length === 1 && flags[0] === 'chicken') {
      // Randy-approved Chicken-only allergy recommendation pair.
      candidates = [foodProducts.beefRecipe, foodProducts.beginnersChoice];
    } else if (usePorkTripeFallback) {
      candidates = [foodProducts.porkMix, foodProducts.tripeVariety];
    } else if (useFishVarietyRoute) {
      // QA Ticket #2: Fish-only allergy should return the approved C1/C2 pair.
      candidates = [foodProducts.healthyVariety, foodProducts.varietyPrey];
    } else if (flags.includes('beef') && flags.includes('chicken')) {
      candidates = [foodProducts.turkeyMix, foodProducts.porkMix];
    } else if (
      pet.type === 'dog'
      && flags.length === 2
      && flags.includes('beef')
      && flags.includes('duck')
    ) {
      // QA routing: Beef + Duck allergy should offer Chicken Mix + Turkey Mix.
      candidates = [foodProducts.chickenMix, foodProducts.turkeyMix];
    } else if (flags.length === 1 && flags[0] === 'beef') {
      candidates = [foodProducts.chickenMix, foodProducts.turkeyMix];
    } else {
      candidates = [
        foodProducts.healthyVariety,
        foodProducts.varietyPrey,
        foodProducts.tripeVariety
      ];
    }

    // Randy's v6 routing explicitly requires Pork Mix + Tripe Variety Mix for
    // the exact Beef + Chicken + Turkey fallback. Preserve that prescribed
    // pair even though the routing sheet also lists beef/chicken in the Tripe
    // box. Every other route continues through the normal allergen filter.
    const routedCandidates = (usePorkTripeFallback || useFishVarietyRoute)
      ? candidates.filter((item) => item.available !== false)
      : filterAllergenUnsafeItems(candidates, flags);

    return routedCandidates.slice(0, 2);
  };

  const routedAddonsForPet = (pet = {}) => {
    const concerns = Array.isArray(pet.concerns) ? pet.concerns : [];
    const hasSkin = concerns.includes('skin');
    const hasDigestion = concerns.includes('digestion');

    if (pet.type === 'cat') {
      const catAddons = [];
      if (hasSkin && ENABLE_SAFE_SEA_FOR_CATS) catAddons.push(addonProducts.safeSea);
      catAddons.push(addonProducts.loveBugs);
      return catAddons;
    }

    if (hasSkin && hasDigestion) {
      return [
        addonProducts.bovineColostrum,
        addonProducts.gutSoothe,
        addonProducts.healthyGut,
        addonProducts.beefLung,
        addonProducts.bisonLung
      ];
    }

    if (hasSkin) {
      return [
        addonProducts.bovineColostrum,
        addonProducts.yeastGuard,
        addonProducts.beefLung,
        addonProducts.bisonLung
      ];
    }

    if (hasDigestion) {
      return [
        addonProducts.healthyGut,
        addonProducts.gutSoothe,
        addonProducts.theWolf,
        addonProducts.beefLung,
        addonProducts.bisonLung
      ];
    }

    return [addonProducts.beefLung, addonProducts.bisonLung];
  };

  const allergenSafeAddonsForPet = (pet = {}, flaggedProteins = []) => (
    filterAllergenUnsafeItems(routedAddonsForPet(pet), flaggedProteins)
  );

  const createPlan = () => ({
    productId: '',
    supply: 'two',
    addonIds: [],
    result: null,
    pricing: null,
    cartProperties: {},
    addonCartProperties: {},
    completed: false,
    cartStatus: 'not-added',
    cartError: ''
  });

  const createPet = () => ({
    name: '',
    type: '',
    breed: '',
    lifeStage: '',
    currentWeight: '',
    idealWeight: '',
    allergies: [],
    concerns: [],
    weightDifferenceConfirmed: false,
    allergyConsultConfirmed: false,
    plan: createPlan()
  });

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const titleCase = (value = '') => value.charAt(0).toUpperCase() + value.slice(1);

  // Scoped CSS additions for the Back buttons and client-requested warning visibility.
  // This only affects the RDF section and keeps the existing theme stylesheet intact.
  const ensureQuizUiStyles = () => {
    const styleId = 'rdf-feed-plan-ux-fixes';
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      [data-rdf-feed-plan] .rdf-back-button {
        align-items: center;
        background: #fffaf5;
        border: 2px solid #8b1a1a;
        border-radius: 999px;
        color: #8b1a1a;
        cursor: pointer;
        display: inline-flex;
        font: inherit;
        font-size: 15px;
        font-weight: 800;
        gap: 7px;
        line-height: 1.3;
        margin: 0 0 18px;
        padding: 10px 18px;
        text-decoration: none;
      }
      [data-rdf-feed-plan] .rdf-back-button:hover {
        background: #8b1a1a;
        color: #fff;
      }
      [data-rdf-feed-plan] .rdf-back-button:focus-visible {
        outline: 3px solid #c9972a;
        outline-offset: 3px;
      }
      [data-rdf-feed-plan] .rdf-error,
      [data-rdf-feed-plan] .rdf-field-error,
      [data-rdf-feed-plan] .rdf-cart-error {
        background: #fff0ed;
        border: 2px solid #b42318;
        border-left-width: 6px;
        border-radius: 9px;
        color: #761c15;
        display: block;
        font-size: 15px;
        font-weight: 800;
        line-height: 1.5;
        margin-top: 12px;
        padding: 12px 15px;
        text-align: left;
      }
      [data-rdf-feed-plan] .rdf-question-card.has-error {
        border: 2px solid #b42318;
        box-shadow: 0 0 0 3px rgba(180, 35, 24, .13);
      }
      [data-rdf-feed-plan] .rdf-name-row.has-error .rdf-input,
      [data-rdf-feed-plan] .rdf-input.is-invalid {
        border-color: #b42318;
        box-shadow: 0 0 0 3px rgba(180, 35, 24, .13);
      }
      [data-rdf-feed-plan] .rdf-modal__title { font-weight: 800; }
      [data-rdf-feed-plan] .rdf-modal__copy { font-weight: 600; }
      /* Keep the modal Back button clearly separated from its primary CTA. */
      [data-rdf-feed-plan] .rdf-modal__back {
        display: flex;
        justify-content: center;
        margin-top: 28px;
      }
      [data-rdf-feed-plan] .rdf-modal__back .rdf-back-button {
        margin: 0;
      }
      /* Consultation results need a stronger warning than the general gold notice. */
      [data-rdf-feed-plan] .rdf-notice--consultation {
        background: #fff9f5;
        border: 2px solid #8b1a1a;
        border-radius: 12px;
        color: #2d2d2d;
        margin: 0 0 24px;
        padding: 20px 22px;
      }
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-section-title {
        color: #8b1a1a;
        font-weight: 800;
      }
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-consultation-copy {
        background: #ffebe7;
        border-left: 6px solid #9d2222;
        border-radius: 8px;
        color: #611b1b;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.6;
        margin: 18px 0 24px;
        padding: 14px 18px;
        text-align: left;
      }
      /* Match the consultation CTA's dimensions, keeping Back clearly secondary. */
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-primary-button {
        box-sizing: border-box;
        width: 100%;
        max-width: 680px;
        min-height: 62px;
      }
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-consultation-back-button {
        background: #fff9f5 !important;
        border: 2px solid #8b1a1a;
        color: #8b1a1a !important;
        margin: 16px auto 0;
      }
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-consultation-back-button:hover {
        background: #f8ecec !important;
        color: #8b1a1a !important;
      }
      [data-rdf-feed-plan] .rdf-notice--consultation .rdf-consultation-back-button:focus-visible {
        outline: 3px solid #c9972a;
        outline-offset: 3px;
      }
    `;
    document.head.appendChild(style);
  };

  class RdfFeedPlanQuiz {
    constructor(root) {
      this.root = root;
      ensureQuizUiStyles();
      this.state = {
        stage: 'setup',
        petCount: 1,
        fulfillment: '',
        pets: [createPet()],
        currentPetIndex: 0,
        error: '',
        note: '',
        nameErrors: [],
        questionErrors: {},
        modal: ''
      };

      this.root.addEventListener('click', (event) => this.handleClick(event));
      this.root.addEventListener('input', (event) => this.handleInput(event));
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.rdf-breed-control')) this.closeBreedSuggestions();
      });
      this.render();
    }

    handleClick(event) {
      const target = event.target.closest('[data-action]');
      if (!target) return;

      event.preventDefault();

      const action = target.dataset.action;
      const previousStage = this.state.stage;
      let animateCounter = false;
      let focusFirstError = false;
      this.state.error = '';
      this.state.note = '';

      if (action === 'pet-count') {
        const previousCount = this.state.petCount;
        const nextCount = Math.min(5, Math.max(1, this.state.petCount + Number(target.dataset.delta)));
        this.resizePets(nextCount);
        animateCounter = nextCount !== previousCount;
      }

      if (action === 'fulfillment') this.state.fulfillment = target.dataset.value;

      if (action === 'go-names') {
        if (!this.state.fulfillment) {
          this.state.error = 'Please choose how you\'d like to receive your order before continuing.';
          focusFirstError = true;
        } else {
          this.state.stage = 'names';
        }
      }

      if (action === 'back-setup') this.state.stage = 'setup';
      if (action === 'back-names') {
        this.state.stage = 'names';
        this.state.modal = '';
        this.state.questionErrors = {};
      }
      if (action === 'back-questions') {
        this.state.stage = 'questions';
        this.state.modal = '';
        this.state.questionErrors = {};
      }
      if (action === 'close-modal') this.state.modal = '';

      if (action === 'go-questions') {
        this.state.nameErrors = this.validateNames();
        if (this.state.nameErrors.some(Boolean)) {
          focusFirstError = true;
        } else {
          // Preserve the active pet when returning from a later pet in a multi-pet order.
          const firstIncomplete = this.state.pets.findIndex((pet) => !pet.plan.completed);
          this.state.currentPetIndex = firstIncomplete >= 0 ? firstIncomplete : 0;
          this.state.stage = 'questions';
        }
      }

      if (action === 'pet-single') {
        const pet = this.currentPet();
        const field = target.dataset.field;
        const value = target.dataset.value;
        if (field === 'type' && pet.type !== value) pet.breed = '';
        pet[field] = value;
        delete this.state.questionErrors[field];
      }

      if (action === 'pet-multi') {
        this.togglePetMulti(target.dataset.field, target.dataset.value);
        if (target.dataset.field === 'allergies') {
          this.currentPet().allergyConsultConfirmed = false;
        }
      }

      if (action === 'select-breed') {
        this.currentPet().breed = target.dataset.value;
        this.closeBreedSuggestions();
      }

      if (action === 'show-result') {
        this.state.questionErrors = this.validateCurrentPet();
        if (Object.keys(this.state.questionErrors).length) {
          focusFirstError = true;
        } else {
          this.attemptShowResult();
        }
      }

      if (action === 'continue-weight-plan') {
        this.currentPet().weightDifferenceConfirmed = true;
        this.state.modal = '';
        this.attemptShowResult();
      }

      if (action === 'continue-allergy-plan') {
        this.currentPet().allergyConsultConfirmed = true;
        this.state.modal = '';
        this.attemptShowResult();
      }

      if (action === 'select-product') this.currentPlan().productId = target.dataset.value;
      if (action === 'select-supply') this.currentPlan().supply = target.dataset.value;

      if (action === 'toggle-addon') {
        const addonId = target.dataset.value;
        const plan = this.currentPlan();
        plan.addonIds = plan.addonIds.includes(addonId)
          ? plan.addonIds.filter((id) => id !== addonId)
          : [...plan.addonIds, addonId];
      }

      if (action === 'complete-pet') {
        this.completeCurrentPet(() => this.addCurrentPlanToCart());
        return;
      }

      if (action === 'download-placeholder') {
        this.state.note = 'The Transition Guide PDF will be connected in the integration phase.';
      }

      if (action === 'checkout-placeholder') {
        window.location.assign('/cart');
        return;
      }

      if (action === 'catalog-placeholder') {
        window.location.assign('/collections/all');
        return;
      }

      if (action === 'reset-demo') {
        this.state.stage = 'setup';
        this.state.petCount = 1;
        this.state.fulfillment = '';
        this.state.pets = [createPet()];
        this.state.currentPetIndex = 0;
        this.state.nameErrors = [];
        this.state.questionErrors = {};
        this.state.modal = '';
      }

      this.render();

      if (animateCounter) this.animateCounter();
      if (focusFirstError) this.focusFirstInvalidField();

      if (this.state.stage !== previousStage) {
        this.scrollToTop();
      }
    }

    handleInput(event) {
      const target = event.target;

      if (target.matches('[data-name-index]')) {
        const index = Number(target.dataset.nameIndex);
        this.state.pets[index].name = target.value;
        if (target.value.trim()) {
          this.state.nameErrors[index] = '';
          target.classList.remove('is-invalid');
          target.removeAttribute('aria-invalid');
          const row = target.closest('.rdf-name-row');
          row?.classList.remove('has-error');
          row?.querySelector('[data-name-error]')?.remove();
        }
      }

      if (target.matches('[data-pet-field]')) {
        const field = target.dataset.petField;
        const pet = this.currentPet();
        pet[field] = target.value;

        if (field === 'currentWeight' || field === 'idealWeight') {
          pet.weightDifferenceConfirmed = false;
        }

        if (field === 'breed') this.updateBreedSuggestions(target);

        const number = Number(target.value);
        const fieldIsValid = field === 'breed'
          || (field === 'idealWeight' && target.value === '')
          || ((field === 'currentWeight' || field === 'idealWeight') && number >= 1 && number <= 300);

        if (fieldIsValid && this.state.questionErrors[field]) {
          delete this.state.questionErrors[field];
          target.classList.remove('is-invalid');
          target.removeAttribute('aria-invalid');
          const card = target.closest('.rdf-question-card');
          card?.querySelector(`[data-error-for="${field}"]`)?.remove();
          if (!card?.querySelector('.rdf-field-error')) card?.classList.remove('has-error');
        }
      }
    }

    resizePets(nextCount) {
      const pets = [...this.state.pets];
      while (pets.length < nextCount) pets.push(createPet());
      this.state.pets = pets.slice(0, nextCount);
      this.state.petCount = nextCount;
      this.state.nameErrors = [...this.state.nameErrors, ...Array(nextCount).fill('')].slice(0, nextCount);
    }

    validateNames() {
      const names = this.state.pets.map((pet) => pet.name.trim());
      const errors = names.map((name, index) => (
        name ? '' : `Please enter a name for Pet ${index + 1}.`
      ));
      const normalizedCounts = names.reduce((counts, name) => {
        if (name) counts[name.toLowerCase()] = (counts[name.toLowerCase()] || 0) + 1;
        return counts;
      }, {});

      names.forEach((name, index) => {
        if (errors[index]) return;
        if (!/^[a-zA-Z][a-zA-Z .'-]{0,29}$/.test(name)) {
          errors[index] = 'Use 1\u201330 letters for this pet name.';
        } else if (normalizedCounts[name.toLowerCase()] > 1) {
          errors[index] = 'Each pet needs a unique name.';
        }
      });

      if (!errors.some(Boolean)) {
        this.state.pets.forEach((pet, index) => { pet.name = names[index]; });
      }

      return errors;
    }

    validateCurrentPet() {
      const pet = this.currentPet();
      const errors = {};
      if (!pet.type) errors.type = `Please select Dog or Cat for ${pet.name}.`;
      if (!pet.lifeStage) {
        errors.lifeStage = pet.type === 'cat'
          ? `Please let us know if ${pet.name} is a kitten or adult cat \u2014 it changes the feeding calculation.`
          : `Please let us know if ${pet.name} is a puppy or adult \u2014 it changes the feeding calculation.`;
      }
      if (!Number(pet.currentWeight) || Number(pet.currentWeight) < 1 || Number(pet.currentWeight) > 300) {
        errors.currentWeight = `We need ${pet.name}\u2019s current weight to calculate the right daily portion size.`;
      }
      if (pet.idealWeight !== '' && (
        !Number(pet.idealWeight) || Number(pet.idealWeight) < 1 || Number(pet.idealWeight) > 300
      )) {
        errors.idealWeight = `Please enter ${pet.name}\u2019s ideal weight between 1 and 300 lbs, or leave it blank.`;
      }
      return errors;
    }

    attemptShowResult() {
      const pet = this.currentPet();
      const currentWeight = Number(pet.currentWeight);
      const idealWeight = Number(pet.idealWeight);
      const hasLargeWeightGap = idealWeight >= 1
        && Math.abs(currentWeight - idealWeight) > 15;

      if (hasLargeWeightGap && !pet.weightDifferenceConfirmed) {
        this.state.modal = 'weight-gap';
        return;
      }

      if (this.requiresConsultation(pet) && !pet.allergyConsultConfirmed) {
        this.state.modal = 'allergy-consult';
        return;
      }

      this.state.modal = '';
      this.initializeCurrentPlan();
      this.state.stage = 'result';
    }

    breedsForCurrentPet() {
      if (this.currentPet().type === 'dog') return DOG_BREEDS;
      if (this.currentPet().type === 'cat') return CAT_BREEDS;
      return [];
    }

    matchingBreeds(query = '') {
      const normalizedQuery = query.trim().toLowerCase();
      if (!normalizedQuery) return [];

      const notListedOption = 'My Breed Not Listed';
      const breeds = this.breedsForCurrentPet();
      if (!breeds.length) return [];

      const matches = breeds
        .filter((breed) => breed !== notListedOption && breed.toLowerCase().includes(normalizedQuery))
        .slice(0, 7);

      return [...matches, notListedOption];
    }

    updateBreedSuggestions(input) {
      const control = input.closest('.rdf-breed-control');
      const suggestions = control?.querySelector('.rdf-breed-suggestions');
      if (!suggestions) return;

      const matches = this.matchingBreeds(input.value);
      suggestions.innerHTML = matches.map((breed) => `
        <button type="button" role="option" data-action="select-breed" data-value="${escapeHtml(breed)}">${escapeHtml(breed)}</button>
      `).join('');
      suggestions.hidden = !matches.length;
      input.setAttribute('aria-expanded', String(Boolean(matches.length)));
    }

    closeBreedSuggestions() {
      this.root.querySelectorAll('.rdf-breed-suggestions').forEach((suggestions) => {
        suggestions.hidden = true;
      });
      this.root.querySelectorAll('[data-breed-input]').forEach((input) => {
        input.setAttribute('aria-expanded', 'false');
      });
    }

    animateCounter() {
      const value = this.root.querySelector('.rdf-counter__value');
      if (!value) return;
      value.classList.remove('is-bouncing');
      window.requestAnimationFrame(() => {
        value.classList.add('is-bouncing');
        value.addEventListener('animationend', () => value.classList.remove('is-bouncing'), { once: true });
      });
    }

    focusFirstInvalidField() {
      window.requestAnimationFrame(() => {
        const invalid = this.root.querySelector('[aria-invalid="true"], .rdf-question-card.has-error button, [data-form-error]');
        invalid?.focus({ preventScroll: true });
        invalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    togglePetMulti(field, value) {
      const pet = this.currentPet();
      const values = pet[field];

      const exclusiveValues = field === 'allergies' ? ['none', 'other'] : ['none'];

      if (exclusiveValues.includes(value)) {
        pet[field] = values.includes(value) ? [] : [value];
        return;
      }

      const withoutExclusiveValues = values.filter((item) => !exclusiveValues.includes(item));
      pet[field] = withoutExclusiveValues.includes(value)
        ? withoutExclusiveValues.filter((item) => item !== value)
        : [...withoutExclusiveValues, value];
    }

    async completeCurrentPet(cartOperation = null) {
      const plan = this.currentPlan();
      const previousStage = this.state.stage;

      if (plan.cartStatus === 'adding' || plan.completed) {
        return false;
      }

      plan.cartStatus = 'adding';
      plan.cartError = '';
      this.render();

      try {
        if (typeof cartOperation === 'function') {
          await cartOperation();
        }

        plan.completed = true;
        plan.cartStatus = cartOperation ? 'added' : 'mock-added';

        const nextIndex = this.state.pets.findIndex((pet) => !pet.plan.completed);
        if (nextIndex >= 0) {
          this.state.currentPetIndex = nextIndex;
          this.state.stage = 'questions';
          this.state.questionErrors = {};
          this.state.modal = '';
        }

        this.render();
        if (this.state.stage !== previousStage) {
          this.scrollToTop();
        }
        return true;
      } catch (error) {
        plan.cartStatus = 'error';
        plan.cartError = error?.message || 'We could not add this plan to the cart. Please try again.';
        this.render();
        return false;
      }
    }

    async addCurrentPlanToCart() {
      const pet = this.currentPet();
      const plan = this.currentPlan();
      const result = plan.result || this.calculateResultFor(pet);
      const products = this.productsForPet(pet);
      const product = products.find((item) => item.id === plan.productId) || products[0];
      const period = result.periods[plan.supply] || result.periods.two;

      if (!product || products.length !== 2 || this.requiresConsultation(pet)) {
        throw new Error('A safe two-product recommendation is required before adding this plan to cart.');
      }

      const flaggedProteins = this.allergyFlagsFor(pet);
      const approvedPorkTripeException = usesPorkTripeFallback(pet, flaggedProteins)
        && product.id === foodProducts.tripeVariety.id;
      const approvedFishVarietyException = usesFishVarietyRoute(pet, flaggedProteins)
        && product.id === foodProducts.varietyPrey.id;
      if (
        hasAllergenConflict(product, flaggedProteins)
        && !approvedPorkTripeException
        && !approvedFishVarietyException
      ) {
        throw new Error('The selected food conflicts with a listed allergy. Please choose another option.');
      }

      const quantity = this.calculateCartQuantityFor(period, product);
      const foodProperties = this.cartPropertiesForCurrentPlan('', product, period, quantity);
      const availableAddons = this.addonsForPet(pet);
      const selectedAddons = plan.addonIds.map((addonId) => (
        availableAddons.find((addon) => addon.id === addonId)
      ));

      if (selectedAddons.some((addon) => !addon)) {
        throw new Error('One of the selected add-ons is no longer available for this plan.');
      }

      return addItemsToShopifyCart({
        products: [{
          variantId: product.variantId,
          quantity: quantity.quantity,
          properties: foodProperties
        }],
        addons: selectedAddons.map((addon) => ({
          variantId: addon.variantId,
          quantity: 1,
          properties: this.cartPropertiesForCurrentPlan(
            addon.name,
            product,
            period,
            quantity
          )
        }))
      });
    }

    currentPet() {
      return this.state.pets[this.state.currentPetIndex];
    }

    currentPlan() {
      return this.currentPet().plan;
    }

    initializeCurrentPlan() {
      const pet = this.currentPet();
      const plan = this.currentPlan();
      const products = this.productsForPet(pet);
      const addons = this.addonsForPet(pet);

      if (this.requiresConsultation(pet)) {
        plan.productId = '';
        plan.addonIds = [];
        plan.pricing = null;
        plan.result = this.calculateResultFor(pet);
        return;
      }

      if (!products.some((product) => product.id === plan.productId)) {
        plan.productId = products[0]?.id || '';
      }

      if (!['two', 'four'].includes(plan.supply)) {
        plan.supply = 'two';
      }

      plan.addonIds = plan.addonIds.filter((addonId) => (
        addons.some((addon) => addon.id === addonId)
      ));

      plan.result = this.calculateResultFor(pet);
    }

    allergyFlagsFor(pet) {
      return pet.allergies.filter((allergy) => allergyProteinKeys.includes(allergy));
    }

    requiresConsultation(pet) {
      const flaggedProteins = this.allergyFlagsFor(pet);
      const allergyModalThresholdReached = flaggedProteins.length >= 5;
      const safeProducts = recommendedProductPoolForPet(pet, flaggedProteins);

      return allergyModalThresholdReached || safeProducts.length !== 2;
    }

    productsForPet(pet) {
      const flaggedProteins = this.allergyFlagsFor(pet);

      if (flaggedProteins.length >= 5) return [];

      const products = recommendedProductPoolForPet(pet, flaggedProteins);
      return products.length === 2 ? products : [];
    }

    currentProducts() {
      return this.productsForPet(this.currentPet());
    }

    addonsForPet(pet) {
      return allergenSafeAddonsForPet(pet, this.allergyFlagsFor(pet));
    }

    currentAddons() {
      return this.addonsForPet(this.currentPet());
    }

    calculationWeightFor(pet) {
      const idealWeight = Number(pet.idealWeight);
      return idealWeight >= 1 && idealWeight <= 300
        ? idealWeight
        : Number(pet.currentWeight);
    }

    feedingRateFor(pet) {
      if (pet.lifeStage === 'puppy') return 0.07;
      return pet.type === 'cat' ? 0.03 : 0.02;
    }

    calculateSupplyPeriod(dailyOz, standardDays) {
      const standardLbs = dailyOz * standardDays / 16;
      const adjusted = this.state.fulfillment === 'shipping' && standardLbs < SHIPPING_MINIMUM_LBS;

      return {
        standardDays,
        days: standardDays,
        adjusted,
        standardLbs,
        totalLbs: standardLbs
      };
    }

    calculateCartQuantityFor(period, variantMapping) {
      return calculateVariantQuantity({
        requiredLbs: period.standardLbs,
        unitWeightLbs: variantMapping.unitWeightLbs,
        fulfillment: this.state.fulfillment,
        minimumShippingQty: variantMapping.minimumShippingQty
      });
    }

    calculateResultFor(pet) {
      const calculationWeight = this.calculationWeightFor(pet);
      const dailyRate = this.feedingRateFor(pet);
      const exactDailyOz = calculationWeight * dailyRate * 16;
      const displayedDailyOz = exactDailyOz.toFixed(1);
      const twoWeek = this.calculateSupplyPeriod(exactDailyOz, 14);
      const fourWeek = this.calculateSupplyPeriod(exactDailyOz, 28);

      return {
        calculationWeight,
        dailyRate,
        exactDailyOz,
        dailyOz: displayedDailyOz,
        dailyLbs: (exactDailyOz / 16).toFixed(2),
        standardTwoWeekLbs: twoWeek.standardLbs.toFixed(1),
        twoWeekLbs: twoWeek.totalLbs.toFixed(1),
        fourWeekLbs: fourWeek.totalLbs.toFixed(1),
        twoWeekDays: twoWeek.days,
        fourWeekDays: fourWeek.days,
        twoWeekAdjusted: twoWeek.adjusted,
        fourWeekAdjusted: fourWeek.adjusted,
        shippingAdjusted: twoWeek.adjusted || fourWeek.adjusted,
        periods: {
          two: twoWeek,
          four: fourWeek
        }
      };
    }

    mockResult() {
      const plan = this.currentPlan();
      const result = this.calculateResultFor(this.currentPet());
      plan.result = result;
      return result;
    }

    cartPropertiesForCurrentPlan(
      addonName = '',
      productOverride = null,
      periodOverride = null,
      quantityOverride = null
    ) {
      const pet = this.currentPet();
      const plan = this.currentPlan();
      const result = plan.result || this.calculateResultFor(pet);
      const products = this.productsForPet(pet);
      const product = productOverride
        || products.find((item) => item.id === plan.productId)
        || products[0];
      const period = periodOverride || result.periods[plan.supply] || result.periods.two;
      const fulfillment = fulfillmentOptions.find((option) => option.id === this.state.fulfillment);

      if (!product || !period) return {};

      const quantity = quantityOverride || this.calculateCartQuantityFor(period, product);

      return buildFeedPlanLineItemProperties({
        petName: pet.name,
        petType: pet.type === 'cat' ? 'Cat' : 'Dog',
        breed: pet.breed,
        lifeStage: pet.type === 'cat' && pet.lifeStage === 'puppy'
          ? 'Kitten'
          : titleCase(pet.lifeStage),
        planName: product.name,
        planKey: `${product.id}:${plan.supply}`,
        supplyDays: period.days,
        dailyOz: result.dailyOz,
        dailyLbs: result.dailyLbs,
        totalLbs: quantity.cartWeightLbs,
        fulfillment: fulfillment?.resultTitle || this.state.fulfillment,
        addonName
      });
    }

    scrollToTop() {
      const top = this.root.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    render() {
      if (this.state.stage === 'setup') this.root.innerHTML = this.renderSetup();
      if (this.state.stage === 'names') this.root.innerHTML = this.renderNames();
      if (this.state.stage === 'questions') this.root.innerHTML = this.renderQuestions();
      if (this.state.stage === 'result') this.root.innerHTML = this.renderResult();
    }

    renderHeader(title, subtitle, kicker = 'Raw Dog Food & Co.') {
      return `
        <p class="rdf-kicker">${escapeHtml(kicker)}</p>
        <h1 class="rdf-page-title">${escapeHtml(title)}</h1>
        <p class="rdf-page-subtitle">${escapeHtml(subtitle)}</p>
        <hr class="rdf-header-rule">
      `;
    }

    renderPrototypeBadge() {
      return '';
    }

    renderBackButton(action, label = 'Back') {
      return `<button class="rdf-back-button" type="button" data-action="${action}">\u2190 ${escapeHtml(label)}</button>`;
    }

    renderSetup() {
      const fulfillmentMarkup = fulfillmentOptions.map((option) => `
        <button
          type="button"
          class="rdf-choice ${this.state.fulfillment === option.id ? 'is-selected' : ''}"
          data-action="fulfillment"
          data-value="${option.id}"
        >
          <span class="rdf-choice__icon" aria-hidden="true">${option.icon}</span>
          <span class="rdf-choice__title">${option.title}</span>
          <span class="rdf-choice__detail">${option.detail.replace('\n', '<br>')}</span>
          ${option.warning ? `<span class="rdf-choice__warning">${option.warning}</span>` : ''}
        </button>
      `).join('');

      return `
        <div class="rdf-setup-flow">
        ${this.renderPrototypeBadge()}
        ${this.renderHeader('Build Your Pet\u2019s Personalized Feeding Plan', 'Let\u2019s start with a couple of quick details about your order.')}
        <div class="rdf-card rdf-card--pet-count">
          <h2 class="rdf-card-title">How many pets are we feeding?</h2>
          <p class="rdf-card-copy">We\u2019ll build a personalized plan for each one.</p>
          <div class="rdf-counter">
            <button class="rdf-counter__button" type="button" data-action="pet-count" data-delta="-1" aria-label="Remove one pet" ${this.state.petCount === 1 ? 'disabled' : ''}>\u2212</button>
            <div class="rdf-counter__value">${this.state.petCount}<span class="rdf-counter__label">${this.state.petCount === 1 ? 'Pet' : 'Pets'}</span></div>
            <button class="rdf-counter__button" type="button" data-action="pet-count" data-delta="1" aria-label="Add one pet" ${this.state.petCount === 5 ? 'disabled' : ''}>+</button>
          </div>
        </div>
        <div class="rdf-card rdf-card--fulfillment">
          <h2 class="rdf-card-title">How would you like to receive your order?</h2>
          <p class="rdf-card-copy">This applies to your whole order \u2014 we\u2019ll confirm quantities per pet next.</p>
          <div class="rdf-choice-grid">${fulfillmentMarkup}</div>
        </div>
        ${this.state.error ? `<p class="rdf-error" role="alert" tabindex="-1" data-form-error>\u26A0 Attention: ${escapeHtml(this.state.error)}</p>` : ''}
        <button class="rdf-primary-button" type="button" data-action="go-names">Continue \u2192</button>
        </div>
      `;
    }

    renderNames() {
      const nameRows = this.state.pets.map((pet, index) => {
        const error = this.state.nameErrors[index] || '';
        return `
        <label class="rdf-name-row ${error ? 'has-error' : ''}">
          <span class="rdf-name-row__number">${index + 1}</span>
          <span class="rdf-name-row__field">
            <input
              class="rdf-input ${error ? 'is-invalid' : ''}"
              type="text"
              maxlength="30"
              value="${escapeHtml(pet.name)}"
              data-name-index="${index}"
              ${pet.plan.completed ? 'readonly aria-readonly="true"' : ''}
              aria-label="Pet ${index + 1} name"
              placeholder="e.g. Paulo"
              ${error ? 'aria-invalid="true"' : ''}
            >
            ${error ? `<span class="rdf-field-error" data-name-error role="alert">\u26A0 Please check: ${escapeHtml(error)}</span>` : ''}
          </span>
        </label>
      `;
      }).join('');

      return `
        <div class="rdf-names-flow">
        ${this.state.pets.some((pet) => pet.plan.completed) ? '' : this.renderBackButton('back-setup')}
        ${this.renderPrototypeBadge()}
        ${this.renderHeader('Who are we feeding?', 'Give each pet a name so we can personalize their plan.')}
        <div class="rdf-card rdf-card--names">
          <h2 class="rdf-card-title">Tell us their names</h2>
          <p class="rdf-card-copy">You can always go back and change the order later.</p>
          <div class="rdf-name-list">${nameRows}</div>
        </div>
        <button class="rdf-primary-button" type="button" data-action="go-questions">Build Our Plans \u2192</button>
        <p class="rdf-helper">You\u2019ll answer a few quick questions for each pet</p>
        </div>
      `;
    }

    renderProgress() {
      return this.state.pets.map((pet, index) => {
        const isDone = pet.plan.completed;
        const className = index === this.state.currentPetIndex ? 'is-current' : isDone ? 'is-complete' : 'is-upcoming';
        return `<span class="rdf-progress-pill ${className}">${escapeHtml(pet.name)}</span>`;
      }).join('');
    }

    renderCompletedCards() {
      return this.state.pets.filter((pet) => pet.plan.completed).map((pet) => {
        const result = pet.plan.result || this.calculateResultFor(pet);
        const products = this.productsForPet(pet);
        const product = products.find((item) => item.id === pet.plan.productId) || products[0];
        return `
          <div class="rdf-completed-card">
            <span class="rdf-completed-card__check">\u2713</span>
            <span>
              <span class="rdf-completed-card__name">${escapeHtml(pet.name)}</span>
              <span class="rdf-completed-card__detail">${escapeHtml(product.name)} \u00B7 ${result.dailyOz} oz (${result.dailyLbs} lbs) per day</span>
            </span>
            <span class="rdf-completed-card__status">In Cart \u2713</span>
          </div>
        `;
      }).join('');
    }

    renderOption(field, value, icon, title, detail = '') {
      const selected = this.currentPet()[field] === value;
      return `
        <button class="rdf-option ${selected ? 'is-selected' : ''}" type="button" data-action="pet-single" data-field="${field}" data-value="${value}">
          <span class="rdf-option__icon" aria-hidden="true">${icon}</span>
          <span class="rdf-option__title">${escapeHtml(title)}</span>
          ${detail ? `<span class="rdf-option__detail">${escapeHtml(detail)}</span>` : ''}
        </button>
      `;
    }

    renderMultiOption(field, value, icon, title, detail = '') {
      const selected = this.currentPet()[field].includes(value);
      return `
        <button class="rdf-option ${selected ? 'is-selected' : ''}" type="button" data-action="pet-multi" data-field="${field}" data-value="${value}">
          <span class="rdf-option__icon" aria-hidden="true">${icon}</span>
          <span class="rdf-option__title">${escapeHtml(title)}</span>
          ${detail ? `<span class="rdf-option__detail">${escapeHtml(detail)}</span>` : ''}
        </button>
      `;
    }

    renderQuestionError(field) {
      const error = this.state.questionErrors[field];
      return error
        ? `<p class="rdf-field-error" data-error-for="${field}" role="alert">\u26A0 Please check: ${escapeHtml(error)}</p>`
        : '';
    }

    renderActiveModal() {
      const pet = this.currentPet();
      if (!this.state.modal) return '';

      if (this.state.modal === 'weight-gap') {
        return `
          <div class="rdf-modal-backdrop">
            <section class="rdf-modal" role="dialog" aria-modal="true" aria-labelledby="rdf-weight-modal-title">
              <span class="rdf-modal__icon" aria-hidden="true">\u2696\uFE0F</span>
              <h2 id="rdf-weight-modal-title" class="rdf-modal__title">A Note on Healthy Weight Goals</h2>
              <p class="rdf-modal__copy">We noticed a significant difference between ${escapeHtml(pet.name)}\u2019s current and ideal weight. A quick conversation with one of our nutritionists will help build a plan that supports safe, steady progress toward a healthy weight.</p>
              <div class="rdf-modal__actions">
                <a class="rdf-outline-button" href="${CONSULTATION_URL}">Book My Consult Now</a>
                <button class="rdf-primary-button" type="button" data-action="continue-weight-plan">Continue to my plan</button>
              </div>
              <div class="rdf-modal__back">${this.renderBackButton('close-modal')}</div>
              ${this.state.note ? `<p class="rdf-helper">${escapeHtml(this.state.note)}</p>` : ''}
            </section>
          </div>
        `;
      }

      const consultationCopy = this.allergyFlagsFor(pet).length >= 5
        ? 'Most pets don\u2019t react to this many proteins \u2014 and our raw feeding experts have helped thousands of sensitive pets find a diet that works. Let\u2019s figure this out together.'
        : `We couldn\u2019t find two mapped food options that avoid all of ${pet.name}\u2019s listed allergies. Our team can help review the safest alternatives.`;

      return `
        <div class="rdf-modal-backdrop">
          <section class="rdf-modal" role="dialog" aria-modal="true" aria-labelledby="rdf-allergy-modal-title">
            <span class="rdf-modal__icon" aria-hidden="true">\u{1F43E}</span>
            <h2 id="rdf-allergy-modal-title" class="rdf-modal__title">We Can Help Find the Right Fit!</h2>
            <p class="rdf-modal__copy">${escapeHtml(consultationCopy)}</p>
            <div class="rdf-modal__actions">
              <a class="rdf-outline-button" href="${CONSULTATION_URL}">Book My Consult Now</a>
              <button class="rdf-primary-button" type="button" data-action="continue-allergy-plan">Continue building this plan anyway</button>
            </div>
            <div class="rdf-modal__back">${this.renderBackButton('close-modal')}</div>
            ${this.state.note ? `<p class="rdf-helper">${escapeHtml(this.state.note)}</p>` : ''}
          </section>
        </div>
      `;
    }

    renderQuestions() {
      const pet = this.currentPet();
      const position = this.state.currentPetIndex + 1;
      const allergyFlagCount = this.allergyFlagsFor(pet).length;

      return `
        <div class="rdf-question-flow">
        ${this.renderBackButton('back-names')}
        ${this.renderPrototypeBadge()}
        ${this.renderHeader(`Tell Us About ${pet.name}`, `Pet ${position} of ${this.state.petCount} \u2014 a few quick questions.`)}
        <div class="rdf-progress-pills">${this.renderProgress()}</div>
        ${this.renderCompletedCards()}
        <div class="rdf-question-stack">
          <div class="rdf-question-card rdf-question-card--type ${this.state.questionErrors.type ? 'has-error' : ''}">
            <p class="rdf-step-label">Step 1</p>
            <h2 class="rdf-question-card__title">Is ${escapeHtml(pet.name)} a dog or a cat?</h2>
            <div class="rdf-option-grid">
              ${this.renderOption('type', 'dog', '\u{1F415}', 'Dog')}
              ${this.renderOption('type', 'cat', '\u{1F408}', 'Cat')}
            </div>
            ${this.renderQuestionError('type')}
          </div>

          <div class="rdf-question-card rdf-question-card--breed">
            <p class="rdf-step-label">Step 2</p>
            <h2 class="rdf-question-card__title">What breed is ${escapeHtml(pet.name)}?</h2>
            <div class="rdf-breed-control">
              <input
                class="rdf-input"
                type="text"
                value="${escapeHtml(pet.breed)}"
                data-pet-field="breed"
                data-breed-input
                placeholder="Start typing to search breeds\u2026"
                autocomplete="off"
                role="combobox"
                aria-autocomplete="list"
                aria-expanded="false"
                aria-controls="rdf-breed-options-${this.state.currentPetIndex}"
              >
              <div id="rdf-breed-options-${this.state.currentPetIndex}" class="rdf-breed-suggestions" role="listbox" hidden></div>
            </div>
          </div>

          <div class="rdf-question-card rdf-question-card--stage ${this.state.questionErrors.lifeStage ? 'has-error' : ''}">
            <p class="rdf-step-label">Step 3</p>
            <h2 class="rdf-question-card__title">${escapeHtml(pet.name)} is a\u2026</h2>
            <div class="rdf-option-grid">
              ${this.renderOption('lifeStage', 'puppy', '\u{1F43E}', pet.type === 'cat' ? 'Kitten' : 'Puppy', 'Under 1 year old')}
              ${this.renderOption('lifeStage', 'adult', '\u{2B50}', 'Adult', 'Over 1 year old')}
            </div>
            ${this.renderQuestionError('lifeStage')}
          </div>

          <div class="rdf-question-card rdf-question-card--weight ${(this.state.questionErrors.currentWeight || this.state.questionErrors.idealWeight) ? 'has-error' : ''}">
            <p class="rdf-step-label">Step 4</p>
            <h2 class="rdf-question-card__title">How much does ${escapeHtml(pet.name)} weigh?</h2>
            <div class="rdf-weight-grid">
              <label>
                <span class="rdf-field-label">Current weight</span>
                <span class="rdf-input-wrap">
                  <input class="rdf-input ${this.state.questionErrors.currentWeight ? 'is-invalid' : ''}" type="number" min="1" max="300" step="1" value="${escapeHtml(pet.currentWeight)}" data-pet-field="currentWeight" ${this.state.questionErrors.currentWeight ? 'aria-invalid="true"' : ''}>
                  <span class="rdf-input-suffix">lbs</span>
                </span>
                ${this.renderQuestionError('currentWeight')}
              </label>
              <label>
                <span class="rdf-field-label">Ideal weight</span>
                <span class="rdf-input-wrap">
                  <input class="rdf-input ${this.state.questionErrors.idealWeight ? 'is-invalid' : ''}" type="number" min="1" max="300" step="1" value="${escapeHtml(pet.idealWeight)}" data-pet-field="idealWeight" ${this.state.questionErrors.idealWeight ? 'aria-invalid="true"' : ''}>
                  <span class="rdf-input-suffix">lbs</span>
                </span>
                ${this.renderQuestionError('idealWeight')}
              </label>
            </div>
          </div>

          <div class="rdf-question-card rdf-question-card--allergies">
            <p class="rdf-step-label">Step 5 \u00B7 Select all that apply</p>
            <h2 class="rdf-question-card__title">Does ${escapeHtml(pet.name)} have any known allergies?</h2>
            <div class="rdf-option-grid rdf-option-grid--allergies">
              ${this.renderMultiOption('allergies', 'chicken', '\u{1F357}', 'Chicken')}
              ${this.renderMultiOption('allergies', 'beef', '\u{1F969}', 'Beef')}
              ${this.renderMultiOption('allergies', 'turkey', '\u{1F983}', 'Turkey')}
              ${this.renderMultiOption('allergies', 'duck', '\u{1F986}', 'Duck')}
              ${this.renderMultiOption('allergies', 'fish', '\u{1F41F}', 'Fish')}
              ${this.renderMultiOption('allergies', 'lamb', '\u{1F411}', 'Lamb')}
              ${this.renderMultiOption('allergies', 'none', '\u{2705}', 'None I know of')}
              ${this.renderMultiOption('allergies', 'other', '\u{2753}', 'Other')}
            </div>
            ${allergyFlagCount >= 4 ? '<p class="rdf-error" role="status">Most proteins are restricted \u2014 we\'ll recommend a consultation when you submit.</p>' : ''}
          </div>

          <div class="rdf-question-card rdf-question-card--concerns">
            <p class="rdf-step-label">Step 6 \u00B7 Select all that apply</p>
            <h2 class="rdf-question-card__title">Any ongoing skin or digestion issues?</h2>
            <div class="rdf-option-grid rdf-option-grid--three">
              ${this.renderMultiOption('concerns', 'none', '\u{1F33F}', 'None that I know of')}
              ${this.renderMultiOption('concerns', 'skin', '\u{1F43E}', 'Itching / Gunky Ears', 'Skin issues')}
              ${this.renderMultiOption('concerns', 'digestion', '\u{1F300}', 'Digestion Problems', 'Gut issues')}
            </div>
          </div>
        </div>
        ${this.state.error ? `<p class="rdf-error" role="alert">${escapeHtml(this.state.error)}</p>` : ''}
        <button class="rdf-primary-button" type="button" data-action="show-result">Get ${escapeHtml(pet.name)}\u2019s Plan \u2192</button>
        <p class="rdf-helper">No email required \u00B7 Results in seconds</p>
        ${this.renderActiveModal()}
        </div>
      `;
    }

    renderProductCard(product, result) {
      const selected = product.id === this.currentPlan().productId;
      const twoWeekPrice = this.calculateSupplyPrice(product, result.periods.two);
      return `
        <button class="rdf-product-card ${selected ? 'is-selected' : ''}" type="button" data-action="select-product" data-value="${product.id}">
          <span class="rdf-product-card__ribbon rdf-product-card__ribbon--${product.ribbonType}">${product.ribbon}</span>
          <h3 class="rdf-product-card__title">${product.icon} ${escapeHtml(product.name)}</h3>
          <p class="rdf-product-card__price">From $${twoWeekPrice.totalPrice.toFixed(2)} for a 2-week supply</p>
          <p class="rdf-product-card__weight">${twoWeekPrice.cartWeightLbs.toFixed(1)} lbs in cart \u00B7 ${twoWeekPrice.quantity} \u00D7 ${product.unitWeightLbs} lb</p>
          <p class="rdf-product-card__copy">${escapeHtml(product.copy)}</p>
          ${selected ? '<span class="rdf-product-card__selected">\u2713 Selected</span>' : ''}
        </button>
      `;
    }

    renderAddonCard(addon) {
      const selected = this.currentPlan().addonIds.includes(addon.id);
      return `
        <article class="rdf-addon-card ${selected ? 'is-selected' : ''}">
          <div class="rdf-addon-card__top"><span class="rdf-addon-card__icon" aria-hidden="true">${addon.icon}</span><strong>$${addon.price.toFixed(2)}</strong></div>
          <h3 class="rdf-addon-card__title">${escapeHtml(addon.name)}</h3>
          <p class="rdf-addon-card__copy">${escapeHtml(addon.copy)}</p>
          <button class="rdf-addon-card__button" type="button" data-action="toggle-addon" data-value="${addon.id}">${selected ? '\u2713 Added' : '+ Add to Order'}</button>
        </article>
      `;
    }

    calculateSupplyPrice(product, period) {
      const quantity = this.calculateCartQuantityFor(period, product);
      const adjustedBasePrice = product.price * quantity.quantity;

      return {
        ...quantity,
        adjustedBasePrice,
        totalPrice: adjustedBasePrice,
        costPerDay: adjustedBasePrice / period.days
      };
    }

    supplyLabel(period, productName) {
      const periodLabel = period.standardDays === 14
        ? '2-WEEK SUPPLY'
        : '4-WEEK SUPPLY';

      return `${periodLabel} OF ${productName.toUpperCase()}`;
    }

    renderConsultationPrompt(pet) {
      return `
        <section class="rdf-result-section">
          <div class="rdf-notice rdf-notice--consultation">
            <h2 class="rdf-section-title">We Can Help Find the Right Fit!</h2>
            <p class="rdf-consultation-copy">We couldn\u2019t find two mapped food options that avoid all of ${escapeHtml(pet.name)}\u2019s listed allergies. Our team can help review safe alternatives and build the right plan.</p>
            <a class="rdf-primary-button" href="${CONSULTATION_URL}">Schedule a Free Consultation</a>
            <button class="rdf-primary-button rdf-consultation-back-button" type="button" data-action="back-questions">← Back</button>
          </div>
        </section>
      `;
    }

    renderResult() {
      const pet = this.currentPet();
      const plan = this.currentPlan();
      const result = this.mockResult();
      const products = this.currentProducts();
      const consultOnly = this.requiresConsultation(pet) || products.length === 0;
      const selectedProduct = consultOnly
        ? null
        : products.find((product) => product.id === plan.productId) || products[0];
      const addons = consultOnly ? [] : this.currentAddons();
      const isComplete = plan.completed;
      const allComplete = this.state.pets.every((item) => item.plan.completed);
      const twoPrice = selectedProduct
        ? this.calculateSupplyPrice(selectedProduct, result.periods.two)
        : null;
      const fourPrice = selectedProduct
        ? this.calculateSupplyPrice(selectedProduct, result.periods.four)
        : null;
      plan.pricing = selectedProduct
        ? { two: twoPrice, four: fourPrice }
        : null;
      const fulfillment = fulfillmentOptions.find((option) => option.id === this.state.fulfillment);
      if (selectedProduct) {
        plan.cartProperties = this.cartPropertiesForCurrentPlan();
        plan.addonCartProperties = Object.fromEntries(
          plan.addonIds.map((addonId) => {
            const addon = addons.find((item) => item.id === addonId);
            return [addonId, this.cartPropertiesForCurrentPlan(addon?.name || addonId)];
          })
        );
      }
      const nextPet = this.state.pets[this.state.currentPetIndex + 1];
      const cartCtaLabel = nextPet
        ? `Add ${pet.name}\u2019s Plan to Cart & Continue to ${nextPet.name} \u2192`
        : `Add to Cart & Start ${pet.name}\u2019s First Order \u2192`;
      const cartIsLoading = plan.cartStatus === 'adding';
      const cartButtonLabel = cartIsLoading
        ? 'Adding to Cart\u2026'
        : cartCtaLabel;

      return `
        <div class="rdf-result">
          ${!consultOnly && !plan.completed && plan.cartStatus !== 'adding' ? this.renderBackButton('back-questions') : ''}
          ${this.renderPrototypeBadge()}
          ${this.renderHeader(`Here\u2019s ${pet.name}\u2019s Plan`, `Personalized for ${pet.name} based on their profile.`, 'Raw Dog Food & Co. \u00B7 My Pet\u2019s Plan')}
          <div class="rdf-progress-pills">${this.renderProgress()}</div>
          <div class="rdf-profile-bar">
            ${this.renderProfileItem('Pet', pet.name)}
            ${this.renderProfileItem('Breed', pet.breed || '\u2014')}
            ${this.renderProfileItem('Life stage', pet.type === 'cat' && pet.lifeStage === 'puppy' ? 'Kitten' : titleCase(pet.lifeStage))}
            ${this.renderProfileItem('Ideal weight', `${result.calculationWeight} lbs`)}
            ${this.renderProfileItem('Daily portion', `${result.dailyOz} oz (${result.dailyLbs} lbs) per day`)}
            ${this.renderProfileItem('Fulfillment', fulfillment.resultTitle)}
          </div>

          ${!consultOnly && result.shippingAdjusted ? '<div class="rdf-notice"><strong>\u{1F4E6} Heads up:</strong> Orders shipped outside Colorado require a 20 lb minimum. Your plan has been adjusted to meet this requirement.</div>' : ''}

          ${consultOnly ? this.renderConsultationPrompt(pet) : `
          <section class="rdf-result-section">
            <h2 class="rdf-section-title">Choose a Starting Option</h2>
            <div class="rdf-product-grid">${products.map((product) => this.renderProductCard(product, result)).join('')}</div>
            <div class="rdf-portion-callout">
              <span class="rdf-portion-callout__icon" aria-hidden="true">\u{1F963}</span>
              <div>
                <strong class="rdf-portion-callout__title">${result.dailyOz} oz (${result.dailyLbs} lbs) per day</strong>
                <p class="rdf-portion-callout__copy">Feed ${escapeHtml(pet.name)} this amount each day, split across 1\u20132 meals. Adjust slightly based on energy and body condition over the first few weeks.</p>
              </div>
            </div>
          </section>

          <section class="rdf-result-section">
            <h2 class="rdf-section-title">Choose Your Supply</h2>
            <div class="rdf-supply-grid">
              <button class="rdf-supply-card ${plan.supply === 'two' ? 'is-selected' : ''}" type="button" data-action="select-supply" data-value="two">
                <span class="rdf-supply-card__eyebrow">${escapeHtml(this.supplyLabel(result.periods.two, selectedProduct.name))}</span>
                <strong class="rdf-supply-card__price">$${twoPrice.totalPrice.toFixed(2)}</strong>
                <span class="rdf-supply-card__detail">$${twoPrice.costPerDay.toFixed(2)} / day</span>
                <span class="rdf-supply-card__detail">${result.periods.two.standardLbs.toFixed(1)} lbs needed for 14 days</span>
                <span class="rdf-supply-card__detail ${twoPrice.shippingMinimumApplied ? 'rdf-supply-card__detail--minimum' : ''}">${twoPrice.cartWeightLbs.toFixed(1)} lbs in cart \u00B7 ${twoPrice.quantity} unit${twoPrice.quantity === 1 ? '' : 's'}${twoPrice.shippingMinimumApplied ? ' \u2726 meets 20 lb min' : ''}</span>
              </button>
              <button class="rdf-supply-card ${plan.supply === 'four' ? 'is-selected' : ''}" type="button" data-action="select-supply" data-value="four">
                <span class="rdf-supply-card__eyebrow">${escapeHtml(this.supplyLabel(result.periods.four, selectedProduct.name))}</span>
                <strong class="rdf-supply-card__price">$${fourPrice.totalPrice.toFixed(2)}</strong>
                <span class="rdf-supply-card__detail">$${fourPrice.costPerDay.toFixed(2)} / day</span>
                <span class="rdf-supply-card__detail">${result.periods.four.standardLbs.toFixed(1)} lbs needed for 28 days</span>
                <span class="rdf-supply-card__detail ${fourPrice.shippingMinimumApplied ? 'rdf-supply-card__detail--minimum' : ''}">${fourPrice.cartWeightLbs.toFixed(1)} lbs in cart \u00B7 ${fourPrice.quantity} unit${fourPrice.quantity === 1 ? '' : 's'}${fourPrice.shippingMinimumApplied ? ' \u2726 meets 20 lb min' : ''}</span>
              </button>
            </div>
          </section>

          <section class="rdf-result-section">
            <h2 class="rdf-section-title">${pet.type === 'cat' ? 'Recommended Supplements' : 'Treats & Supplements'}</h2>
            <div class="rdf-addon-grid">${addons.map((addon) => this.renderAddonCard(addon)).join('')}</div>
          </section>

          <section class="rdf-result-section rdf-result-section--guide">
            <div class="rdf-guide-row">
              <span class="rdf-guide-row__icon" aria-hidden="true">\u{1F4C4}</span>
              <span>
                <span class="rdf-guide-row__title">Raw Feeding Transition Guide</span>
                <span class="rdf-guide-row__copy">New to raw? Download our free step-by-step guide.</span>
              </span>
              <a
  class="rdf-outline-button"
  href="https://cdn.shopify.com/s/files/1/1242/8840/files/Raw_Feeding_Guide_Clickable_Callouts_1.pdf?v=1789140195"
  target="_blank"
  download
>
  Download Free
</a>
            </div>
          </section>

${!isComplete ? `
  <button
    class="rdf-primary-button"
    type="button"
    data-action="complete-pet"
    ${cartIsLoading ? 'disabled aria-busy="true"' : ''}
  >${escapeHtml(cartButtonLabel)}</button>

  ${plan.cartError ? `<p class="rdf-error rdf-cart-error" role="alert">${escapeHtml(plan.cartError)}</p>` : ''}

  <a
    class="rdf-secondary-link"
    href="${CONSULTATION_URL}"
  >
    Not sure? Schedule a Free Consultation
  </a>
` : ''}

          ${allComplete ? this.renderAllSet() : ''}
          `}
          ${this.state.note ? `<p class="rdf-helper">${escapeHtml(this.state.note)}</p>` : ''}
        </div>
      `;
    }

    renderProfileItem(label, value) {
      return `<div class="rdf-profile-item"><span class="rdf-profile-item__label">${escapeHtml(label)}</span><span class="rdf-profile-item__value">${escapeHtml(value)}</span></div>`;
    }

    renderAllSet() {
      const names = this.state.pets.map((pet) => pet.name).join(', ');
      return `
        <div class="rdf-all-set">
          <h2 class="rdf-all-set__title">You\u2019re all set! \u{1F43E}</h2>
          <p class="rdf-all-set__copy">You\u2019ve built personalized plans for <strong>${escapeHtml(names)}</strong>. Everything is in your cart and ready to go.</p>
          <button class="rdf-all-set__button" type="button" data-action="checkout-placeholder">Go to Your Cart & Begin Checkout \u2192</button>
          <button class="rdf-all-set__button rdf-all-set__button--outline" type="button" data-action="catalog-placeholder">Visit Our Catalog &amp; Keep Shopping</button>
        </div>
      `;
    }
  }

  globalThis.RdfFeedPlanUtils = {
    ...(globalThis.RdfFeedPlanUtils || {}),
    RdfFeedPlanQuiz,
    SHIPPING_MINIMUM_LBS,
    SHOPIFY_CART_ADD_ENDPOINT,
    ENABLE_SAFE_SEA_FOR_CATS,
    foodProducts,
    addonProducts,
    mappedShopifyItems,
    selectShopifyVariant,
    unitWeightFromVariant,
    liveProductName,
    applyShopifyProductData,
    shopifyProductJsonUrl,
    fetchShopifyProductData,
    hydrateMappedProductsFromShopify,
    calculateVariantQuantity,
    normalizeEquivalentSupplyPrices,
    buildFeedPlanLineItemProperties,
    buildShopifyCartItems,
    buildShopifyCartAddPayload,
    shopifyCartAddEndpoint,
    addItemsToShopifyCart,
    proteinKeysForItem,
    hasAllergenConflict,
    filterAllergenUnsafeItems,
    hasSensitiveConcerns,
    usesPorkTripeFallback,
    usesFishVarietyRoute,
    recommendedProductPoolForPet,
    routedAddonsForPet,
    allergenSafeAddonsForPet
  };

  const initialize = async () => {
    const roots = [...document.querySelectorAll('[data-rdf-feed-plan]')]
      .map((section) => section.querySelector('[data-rdf-app]'))
      .filter((root) => root
        && root.dataset.initialized !== 'true'
        && root.dataset.initializing !== 'true');

    if (!roots.length) return;

    roots.forEach((root) => {
      root.dataset.initializing = 'true';
      root.innerHTML = '<div class="rdf-card"><p class="rdf-helper">Loading current Shopify product details\u2026</p></div>';
    });

    try {
      await hydrateMappedProductsOnce();
    } catch (error) {
      // Static routing data remains available as a safe fallback.
    }

    roots.forEach((root) => {
      delete root.dataset.initializing;
      root.dataset.initialized = 'true';
      new RdfFeedPlanQuiz(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
